import {Component, Input} from '@angular/core';
import {OfferLocationTransport} from "@core/shared/models/offer/offer-location/offer-location-transport";

@Component({
    selector: 'app-core-offer-location-transport-calculation-thumbnail',
    templateUrl: './offer-location-transport-calculation-thumbnail.component.html',
    styleUrl: './offer-location-transport-calculation-thumbnail.component.scss',
    standalone: false
})
export class OfferLocationTransportCalculationThumbnailComponent {

    @Input() offerLocationTransport: OfferLocationTransport;

    protected readonly Math = Math;

    protected readonly parseFloat = parseFloat;

    public formatDuration(seconds: number): string {

        // Arrondi à la minute la plus proche

        let totalMinutes: number = Math.round(seconds / 60);

        // Durée minimale : 1 minute

        if (totalMinutes < 1) {

            totalMinutes = 1;
        }

        const hours: number = Math.floor(totalMinutes / 60);

        const minutes: number = totalMinutes % 60;

        if (hours > 0) {

            return minutes > 0 ? `${hours}h ${minutes}min` : `${hours} h`;

        } else {

            return `${minutes} min`;
        }
    }

    get distanceLabel(): string {

        switch (this.offerLocationTransport.transport.type){

            case 'train-station':

                return 'distance.from.trainStation.value';

            case 'airport':

                return 'distance.from.airport.value';

            default:

                return 'distance.value';
        }
    }
}
